import {Component, OnInit} from '@angular/core';
import {AhmService} from "../../services/ahm.service";
import {AjaxService} from '../../services/ajax.service';
import {User} from '../../dto/user';
import {Answer} from '../../dto/answer';
import {Md5} from 'ts-md5/dist/md5';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {DialogBodyComponent} from '../dialog/dialog-body/dialog-body.component';
import {transition, trigger, useAnimation} from "@angular/animations";
import {bounce, shake} from "ng-animate";

@Component({
    selector: 'login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.css'],
    animations: [
        trigger('bounce', [transition('* => go', useAnimation(bounce))]),
        trigger('shake', [transition('* => go', useAnimation(shake))])
    ]
})
export class LoginFormComponent implements OnInit {

    public employees = [];


    loginform = 'LOGIN FORM';
    mobile = 'MOBILE PHONE';
    login = 'LOG IN';
    close = 'CLOSE';
    paysub = 'buy subscribe';
    license = 'license agreement';
    // big colorful buttons
    news = 'NEWS';
    buy = 'BUY';
    read = 'READ';
    map = 'S. MAP';
    promo = 'PROMO';
    events = 'EVENTS';
    discuss = 'DISCUSS';
    instr = 'INSTR.';
    mobileEmailUser = 'demo@ahm-pro.com';

    userPassword = 'FREE';
    userPasswordConfirmation;
    confirmationVidibility = 'none';
    loginVisibility = 'inline';
    passwordField = 'text';
    codeVisibility = 'none';
    registrationCode = '';
    registrationCodeFromServer = '';
    registerDisplay = 'inline';

    constructor(private service: AhmService, private ajax: AjaxService, private matDialog: MatDialog) {
        // login form
        // this.loginform = 'LOGIN FORM';
        // this.mobile = 'MOBILE PHONE';
        // this.login = 'LOG IN';
        // this.close = 'CLOSE';
        // this.paysub = 'buy subscribe';

    }

    openDialog(text) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = text;
        this.matDialog.open(DialogBodyComponent, dialogConfig);
    }

    ngOnInit() {
        // this._employeeService.getEmployees().subscribe(data => this.employees = data);
        this.service.setLoginFormComponentLink(this);
        this.service.translateComponent(this, 'login-form');
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    //
    newsAnimation: any;
    buyAnimation: any;
    readAnimation: any;
    donateAnimation: any;
    aboutAnimation: any;
    eventsAnimation: any;
    communityAnimation: any;
    instrumentsAnimation: any;
    loginAnimation: any;
    registerAnimation: any;

    async registerForm() {

        //console.log('this.mobileEmailUser', this.mobileEmailUser);
        if ('demo@ahm-pro.com' !== this.mobileEmailUser) {
            const isEmail = this.validateEmail(this.mobileEmailUser);
            // console.log('isEmail', isEmail);
            if (isEmail) {
                if ('none' === this.confirmationVidibility) {
                    this.confirmationVidibility = 'block';
                    this.openDialog('enter password confirmation and press register button again');
                    // login button hide
                    this.loginVisibility = 'none';
                } else {
                    if (this.userPasswordConfirmation === this.userPassword) {
                        const md5 = new Md5();
                        const md5UserPassword = md5.appendStr(this.userPassword).end();
                        const answer: Answer = await this.ajax.registerStep1(this.mobileEmailUser, md5UserPassword);
                        if ('success' === answer.result) {
                            this.openDialog('enter registration code from e-mail');
                            // console.log('answer -> ', answer);
                            this.codeVisibility = 'block';
                            this.registerDisplay = 'none';
                            // this.registrationCodeFromServer = answer.context;
                        } else {
                            this.openDialog('registration faild. validate data and try again');
                            this.registerDisplay = 'inline';
                            this.loginVisibility = 'inline';
                        }
                    } else {
                        this.openDialog('password and confirmation different. update and repeat all');
                    }
                }
            } else {
                // todo: hightlight field with red color
                this.openDialog('email required');
            }
        } else {
            this.openDialog('Demo User Can Not Be Registered');
        }
    }

    /**
     *
     */
    async sendRegistrationCode() {
        // confirmation request to the server
        const md5 = new Md5();
        const md5UserPassword = md5.appendStr(this.userPassword).end();
        const answer: Answer = await this.ajax.registerStep2(this.mobileEmailUser, md5UserPassword, this.registrationCode);
        if ('success' === answer.result) {
            this.loginVisibility = 'visible';
            this.confirmationVidibility = 'none';
            this.codeVisibility = 'none';
            this.openDialog('registration procedure finished. now sign in');
            this.registerDisplay = 'inline';
            this.loginVisibility = 'inline';
        } else {
            this.openDialog('enter valid code from email. check spam folder for a case');
        }
    }

    async resendCodeInMail() {
        // confirmation request to the server
        const md5 = new Md5();
        const md5UserPassword = md5.appendStr(this.userPassword).end();
        const answer: Answer = await this.ajax.resendCode(this.mobileEmailUser, md5UserPassword);
        return answer;
    }

    text2Password() {
        this.passwordField = 'password';
    }

    /**
     * Login button pressed
     */
    async loginAct() {
        if (
            ('demo@ahm-pro.com' === this.mobileEmailUser) &&
            ('FREE' === this.userPassword)
        ) {
            this.openDialog('use demo version of site');
            this.service.hideLoginForm();
            this.service.setLoginOk('demo@ahm-pro.com');
        } else {
            const md5 = new Md5();
            const md5UserPassword = md5.appendStr(this.userPassword).end();
            const answer: Answer = await this.ajax.sighIn(this.mobileEmailUser, md5UserPassword);
            if (answer.result !== 'success') {
                if (answer.context === 'activation') {
                    this.openDialog('finish activation. enter code from e-mail');
                    this.codeVisibility = 'block';
                    this.registerDisplay = 'none';
                    this.loginVisibility = 'none';
                } else if  (answer.context === 'auth') {
                    this.openDialog('⊠ email/mobile or password wrong');
                }else if  (answer.context === '0') {
                    this.openDialog('no such user');
                }
            } else {
                this.openDialog('✓ welcome login successful');
                this.ajax.setUserId(Number(answer.context));
                this.service.hideLoginForm();
                this.service.setLoginOk();
            }
        }
    }

    developing() {
        this.service.developmentAlert();
    }

    instrumentsOption() {
        setTimeout( () => {
            this.service.instrumentsContent();
        }, 400);
    }

    communityOption() {
        setTimeout( () => {
            this.service.communityContent();
        }, 400);
    }

    eventsOption() {
        setTimeout( () => {
            this.service.eventsContent();
        }, 400);
    }

    aboutOption() {
        setTimeout( () => {
                this.service.loadAboutContent();
        }, 400);
    }

    donateOption() {
        setTimeout( () => {
            this.service.donateContentBlock();
        }, 400);
    }

    readOption() {
        setTimeout( () => {
            this.service.readContentBlock();
        }, 400);
    }

    buyOption() {
        setTimeout( () => {
            this.service.buyContentBlock();
        }, 400);
    }

    newsOption() {
        setTimeout( () => {
            this.service.newsContentBlock();
        }, 400);
    }
}
